/* CHYRONYX — Entrance Animations (replaces Framer Motion) */
(function(){
  var els = document.querySelectorAll('.chx-animate');
  if (!els.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        io.unobserve(entry.target);
      }
    });
  }, {threshold:0.15});
  els.forEach(function(el){ io.observe(el); });
})();
